import "./index.scss";
import domReady from "@wordpress/dom-ready";

const { Swiper } = await import("swiper");
const { Pagination, Autoplay } = await import("swiper/modules");

domReady(function () {
  new Swiper(".peesy-swiper-hero", {
    spaceBetween: 30,
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    modules: [Pagination, Autoplay],
  });
});
